/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import CurrencyIcon from '../../../components/CurrencyIcon';
import BasicContainer from '../../../components/BasicContainer';

const AddAccount = ({
  label,
  subLabel,
  onClick,
  disabled,
  className,
  icon,
  iconSize,
  isConnectYourAccount,
  isImg,
  noMobile,
  imageStyle,
  withoutAction,
}) => {
  const { t: translate } = useTranslation();
  if (!isConnectYourAccount) {
    return <></>;
  }

  if (isMobile && !noMobile) {
    return (
      <div
        onClick={disabled ? undefined : onClick}
        aria-hidden="true"
        className={` d-flex flex-column justify-content-end pb-3 ${isMobile ? 'mb-4' : ''}`}>
        <div className="d-flex align-items-center">
          <p className={`text-f6 text-bold ${disabled ? 'text-disabled' : 'text-white'}`}>
            {label || translate('add_accounts_label')}
          </p>
          <i
            style={{ fontSize: '1.12rem' }}
            className={`icon icon-add-outline cursor-pointer ms-2 ${
              disabled ? 'text-disabled' : 'text-white'
            }`}
            role="button"
            aria-label={label || translate('manage_your_accounts_label')}
            tabIndex={0}
          />
        </div>
      </div>
    );
  }

  return (
    <BasicContainer
      className={`${className} ${subLabel ? 'py-3' : ''} ${
        !withoutAction ? 'cursor-pointer hover-container' : ''
      } bg-lighter px-4 ${disabled ? 'disabled-block' : ''} 
      ${isMobile && 'mb-2'}`}
      onClick={onClick}>
      <div
        className={`d-flex flex-row align-items-center ${
          !withoutAction ? 'justify-content-between' : 'justify-content-start'
        }`}>
        <div
          className={`d-flex flex-row align-items-center ${
            !withoutAction ? 'justify-content-start' : 'justify-content-between'
          }`}>
          {isImg && <CurrencyIcon currencyCode={icon} style={imageStyle} className="m-0" />}

          {!Array.isArray(icon) && !isImg && (
            <div
              className="bg-light d-flex justify-content-center"
              style={{ borderRadius: '24px', padding: '0.75rem' }}>
              <i className={`icon ${icon} ${iconSize} text-white`} />
            </div>
          )}

          {Array.isArray(icon) && !isImg && (
            <span
              style={{ width: '1.5rem', height: '1.5rem' }}
              className={`icon ${icon[0]} text-f4 text-white`}>
              {[...Array(icon[1] + 1).keys()].map((v) => {
                if (v !== 0) {
                  return <span key={`item-${v}`} className={`path${v}`} />;
                }
                return '';
              })}
            </span>
          )}

          <div className={`d-flex flex-column ms-2 ${!withoutAction ? '' : 'ms-4'}`}>
            <p>
              <b>{label || translate('manage_accounts_label')}</b>
            </p>
            {subLabel && <p className="text-shadow text-f6 custom-subtext">{subLabel}</p>}
          </div>
        </div>
        {!withoutAction && (
          <i
            style={{ width: '1rem' }}
            className="icon icon-arrow-next-navigation text-primary text-f4 cursor-pointer"
            role="button"
            aria-label={label || translate('manage_your_accounts_label')}
            tabIndex={0}
            onKeyDown={() => {}}
            onClick={() => {}}
          />
        )}
      </div>
    </BasicContainer>
  );
};

export default AddAccount;

AddAccount.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  disabled: PropTypes.bool,
  subLabel: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  isConnectYourAccount: PropTypes.bool,
  isImg: PropTypes.bool,
  noMobile: PropTypes.bool,
  imageStyle: PropTypes.object,
  iconSize: PropTypes.string,
  withoutAction: PropTypes.bool,
};

AddAccount.defaultProps = {
  subLabel: null,
  label: null,
  disabled: null,
  className: '',
  isConnectYourAccount: true,
  isImg: false,
  noMobile: false,
  imageStyle: {},
  iconSize: 'text-f4',
  withoutAction: false,
};
